import {FormErrors, FormValues} from '../types';

export interface AuthFormDefaultState {
  error: string;
  notification: string;
  formErrors: FormErrors;
  formValues: FormValues;
  step: number;
  waitingForResponse: boolean;
}

export enum ErrorTypes {
  HEAD = `head`,
  EXPIRED_NONCE = `expired_nonce`,
}
